<template>
  <div
    class="footer-box flex flex-center align-items-cnenter"
    :class="FootType === 1 ? 'bg-560a0f' : 'bg-B9202F'"
  >
    <div class="text-box flex flex-center align-items-cnenter">
      <!--<div>{{ getRegion() }}教育局</div>-->
      <div>山西省教育厅</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    FootType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getRegion() {
      if (this.$store.state.region === 1) {
        return "吕梁市";
      } else if (this.$store.state.region === 2) {
        return "临汾市";
      } else if(this.$store.state.region === 3){
        return "长治市";
      }else if(this.$store.state.region === 5){
        return "山西省";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.footer-box {
  height: 60px;
  line-height: 60px;
  font-size: 19px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.87;
}
.footer-box .text-box div {
  margin: 0 20px;
}
.span-color-73151a {
  color: #73151a;
}
.span-color-fff {
  color: #fff;
}
.bg-560a0f {
  background: #560a0f;
}
.bg-B9202F {
  background: #2155B5;
}
</style>
